(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  };

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();
  const productInfo = [
    { match: 'trifold-wallet', style: 'AK-001', name: '3つ折り財布', spec: 'TEIL', regular: '¥220,000', exhibition: '¥187,000' },
    { match: 'passport-wallet', style: 'AK-002', name: 'パスポートケース', spec: 'TEIL', regular: '¥330,000', exhibition: '¥280,500' },
    { match: 'tote-bag', style: 'AK-003', name: 'ミニトート', spec: 'TEIL', regular: '¥770,000', exhibition: '¥654,500' },
    { match: 'shoulder-bag', style: 'AK-004', name: 'ボディーバック', spec: 'TEIL', regular: '¥495,000', exhibition: '¥420,750' },
    { match: 'drawstring-pouch', style: 'AK-005', name: '巾着', spec: 'TEIL', regular: '¥495,000', exhibition: '¥420,750' },
  ];

  const getInfoFromHref = (href) => productInfo.find((item) => (href || '').includes(`/products/${item.match}`));
  const getInfoFromPath = () => getInfoFromHref(window.location.pathname);

  const applyKokiLiveFixes = () => {
    if (!document.getElementById('koki-live-fix-style')) {
      const style = document.createElement('style');
      style.id = 'koki-live-fix-style';
      style.textContent = `
        .header--wrapper{position:relative!important;display:grid!important;grid-template-columns:minmax(92px,auto) 1fr minmax(64px,auto)!important;grid-template-areas:"logo nav language"!important;align-items:center!important;min-height:56px!important;padding-left:28px!important;padding-right:28px!important;column-gap:24px!important}
        .header--logo{grid-area:logo!important;justify-self:start!important}
        .header--primary-nav{grid-area:nav!important;justify-self:center!important;display:flex!important;min-width:0!important}
        .header--secondary-nav{grid-area:language!important;justify-self:end!important;margin-right:0!important}
        .template-index [id^="shopify-section-sections--27081622389034__header"] .header--primary-nav,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--primary-nav{justify-self:center!important}
        .header--primary-nav .x-menu--level-1--container{justify-content:center!important;gap:clamp(18px,2.4vw,34px)!important}
        .template-index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper::before,.template-index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper:before,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper::before,body.template--index [id^="shopify-section-sections--27081622389034__header"] .header--wrapper:before{content:none!important;display:none!important}
        .header--primary-nav .x-menu--level-1--link:first-child{display:block!important}
        .header--primary-nav .x-menu--level-1--link:nth-child(n+6),.y-menu--level-1--link:nth-child(n+6){display:none!important}
        .header--cart,.header--account,.header--search,.header--search-container{display:none!important}
        .koki-footer{display:block!important;visibility:visible!important;opacity:1!important}
        .koki-home-hit{position:absolute!important;left:28px!important;top:0!important;z-index:3!important;width:104px!important;height:56px!important;display:block!important}
        .koki-contact__title,.koki-reservation__title,.koki-store__title,.koki-page-content__title,.koki-exhibition__title,.koki-product-title{font-size:22px!important;font-weight:500!important}
        .koki-contact__required{color:transparent!important;font-size:0!important;line-height:1!important}
        .koki-contact__required::after{content:"*"!important;color:#000!important;font-size:12px!important;line-height:1!important}
        .koki-btn-cart{display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#fff!important;text-align:center!important;text-decoration:none!important;line-height:1.4!important}
        .koki-btn-cart:visited,.koki-btn-cart:hover,.koki-btn-cart:focus{color:#fff!important}
        .koki-btn-cart-full{width:100%!important}
        .koki-product-meta{display:grid!important;gap:8px!important;margin:0 0 36px!important;padding:18px 0!important;border-top:1px solid #e0e0e0!important;border-bottom:1px solid #e0e0e0!important;font-size:12px!important;line-height:1.7!important;letter-spacing:.04em!important}
        .koki-product-meta-row{display:grid!important;grid-template-columns:110px 1fr!important;gap:16px!important}
        .koki-product-meta-term{color:#666!important}
        .koki-product-meta-value{color:#000!important}
        @media(max-width:767px){.koki-product-meta-row{grid-template-columns:92px 1fr!important;gap:12px!important}}
        @media(max-width:767px){.header--wrapper{grid-template-columns:minmax(80px,1fr) auto auto!important;grid-template-areas:"logo language drawer"!important;min-height:54px!important;padding-left:18px!important;padding-right:18px!important}.header--primary-nav{display:none!important}.header--drawer-toggle{grid-area:drawer!important;display:inline-flex!important;justify-self:end!important}.koki-home-hit{left:18px!important;height:54px!important}}
      `;
      document.head.appendChild(style);
    }

    document.querySelectorAll('.header--root a, .x-menu a, .y-menu a').forEach((link) => {
      const label = normalizeText(link.textContent);
      if (label === 'COLLECTIONS') link.setAttribute('href', '/collections/all');
      if (label === 'STORE') link.setAttribute('href', '/pages/store');
      if (label === 'CONTACT') link.setAttribute('href', '/pages/contact');
      if (label === 'OUR STORY') link.setAttribute('href', '/pages/our-story');
      if (label === 'HOME') link.setAttribute('href', '/');
    });

    document.querySelectorAll('.header--primary-nav .x-menu--level-1--link').forEach((item, index) => {
      item.style.setProperty('display', index < 5 ? 'flex' : 'none', 'important');
    });

    document.querySelectorAll('.y-menu--level-1--link').forEach((item, index) => {
      item.style.setProperty('display', index < 5 ? 'block' : 'none', 'important');
    });

    document.querySelectorAll('.koki-store__map[href="#"]').forEach((link) => {
      link.setAttribute('href', '/pages/store');
    });

    document.querySelectorAll('.koki-store__reserve[href="#"]').forEach((link) => {
      link.setAttribute('href', '/pages/reservation');
    });

    document.querySelectorAll('.koki-contact__required').forEach((marker) => {
      marker.textContent = '*';
    });

    document.querySelectorAll('button.koki-btn-cart').forEach((button) => {
      button.setAttribute('type', 'button');
      button.setAttribute('aria-label', '来店予約ページへ移動');
      if (button.dataset.kokiReservationReady === 'true') return;
      button.dataset.kokiReservationReady = 'true';
      button.addEventListener('click', () => {
        window.location.href = '/pages/reservation';
      });
    });

    document.querySelectorAll('a.koki-btn-cart').forEach((link) => {
      link.setAttribute('href', '/pages/reservation');
    });

    document.querySelectorAll('.koki-btn-cart').forEach((button) => {
      button.style.setProperty('display', 'inline-flex', 'important');
      button.style.setProperty('align-items', 'center', 'important');
      button.style.setProperty('justify-content', 'center', 'important');
      button.style.setProperty('color', '#fff', 'important');
      button.style.setProperty('text-align', 'center', 'important');
      button.style.setProperty('text-decoration', 'none', 'important');
    });

    const pageInfo = getInfoFromPath();
    if (pageInfo) {
      document.querySelectorAll('.koki-product-price, .koki-gallery-bar-price, .koki-sticky-bottom-price').forEach((node) => {
        node.textContent = pageInfo.regular;
      });

      const infoTarget = document.querySelector('.koki-product-info');
      if (infoTarget && !infoTarget.querySelector('.koki-product-meta')) {
        const cta = infoTarget.querySelector('[data-koki-main-cta], .koki-btn-cart-full');
        const meta = document.createElement('div');
        meta.className = 'koki-product-meta';
        meta.setAttribute('aria-label', '商品情報');
        meta.innerHTML = [
          ['Style No', pageInfo.style],
          ['商品', pageInfo.name],
          ['仕様', pageInfo.spec],
          ['定価税込', pageInfo.regular],
        ].map(([term, value]) => `<div class="koki-product-meta-row"><span class="koki-product-meta-term">${term}</span><span class="koki-product-meta-value">${value}</span></div>`).join('');
        if (cta) cta.insertAdjacentElement('afterend', meta);
        else infoTarget.insertBefore(meta, infoTarget.firstChild);
      }
    }

    const exhibitionMode = new URLSearchParams(window.location.search).get('view') === 'exhibition-price';
    document.querySelectorAll('.koki-product-card').forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const info = getInfoFromHref(link && link.getAttribute('href'));
      const price = card.querySelector('.koki-card-price');
      if (!info || !price) return;
      price.textContent = exhibitionMode ? `Exhibition Price: ${info.exhibition}` : info.regular;
    });

    document.querySelectorAll('.koki-contact__title, .koki-reservation__title, .koki-store__title, .koki-page-content__title, .koki-exhibition__title, .koki-product-title').forEach((title) => {
      title.style.fontSize = '22px';
      title.style.fontWeight = '500';
    });

    document.querySelectorAll('.header--wrapper').forEach((wrapper) => {
      if (wrapper.querySelector('.koki-home-hit')) return;
      const homeHit = document.createElement('a');
      homeHit.className = 'koki-home-hit';
      homeHit.href = '/';
      homeHit.setAttribute('aria-label', 'HOME');
      wrapper.appendChild(homeHit);
    });
  };

  ready(() => {
    applyKokiLiveFixes();
    window.setTimeout(applyKokiLiveFixes, 250);
    window.setTimeout(applyKokiLiveFixes, 1000);
  });

  document.addEventListener('shopify:section:load', applyKokiLiveFixes);
})();
